import { createRequestConstantNames } from 'store/util/createConstants';
import createReduxConstant from 'store/util/createReduxConstant';

export const [
  FETCH_ANNIVERSARIES_BY_LOCATION,
  FETCH_ANNIVERSARIES_BY_LOCATION_SUCCESS,
  FETCH_ANNIVERSARIES_BY_LOCATION_FAIL,
] = createRequestConstantNames(createReduxConstant('FETCH_ANNIVERSARIES_BY_LOCATION'));
